module.exports = __webpack_public_path__ + "static/media/pc.9210ef6f.svg";